import type { Components, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

/** Fingers need 44px targets; a mouse on a wide screen keeps the denser desktop sizes. */
export const touch = '@media (pointer: coarse), (max-width: 899.95px)';
export const target = { [touch]: { minHeight: 44 } };
export const ease = 'cubic-bezier(0.2, 0, 0, 1)';

// Fine paper grain behind every surface, so the bone canvas does not read as a flat fill.
const grain = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`;

export const base: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: (t) => ({
      html: { '@media (prefers-reduced-motion: no-preference)': { scrollBehavior: 'smooth' } },
      body: { fontVariantNumeric: 'tabular-nums', WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale', fontFeatureSettings: '"ss01", "cv11"' },
      'body::before': { content: '""', position: 'fixed', inset: 0, zIndex: -1, pointerEvents: 'none', opacity: 0.035, backgroundImage: grain },
      '::selection': { backgroundColor: alpha(t.palette.secondary.main, 0.2) },
      '*, *::before, *::after': { transitionProperty: 'color, background-color, border-color, box-shadow, transform, opacity', transitionDuration: '180ms', transitionTimingFunction: ease },
      ':where(a, button, [role="button"], [role="tab"], [tabindex]):focus-visible': { outline: `2px solid ${t.palette.secondary.main}`, outlineOffset: 2 },
      '@media (prefers-reduced-motion: reduce)': {
        '*, *::before, *::after': { animationDuration: '0.01ms !important', animationIterationCount: '1 !important', transitionDuration: '0.01ms !important' },
      },
    }),
  },
  MuiTypography: {
    styleOverrides: { root: { textWrapStyle: 'pretty' } },
    defaultProps: { variantMapping: { overline: 'p' } },
  },
  MuiLink: { defaultProps: { underline: 'hover' }, styleOverrides: { root: ({ theme: t }) => ({ color: t.palette.text.primary, textDecorationColor: alpha(t.palette.text.primary, 0.3), textUnderlineOffset: 3 }) } },
  MuiDivider: { styleOverrides: { root: ({ theme: t }) => ({ borderColor: t.palette.divider }) } },
};
